
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Modal } from 'semantic-ui-react'
import { getHasError, getError } from '../selectors'
import { setError } from '../actions'


class ErrorMessage extends React.Component {
	state = { open: this.props.hasError }

	close = () => {
		this.setState({ open: false })
		this.props.clearError()
	}

	componentWillReceiveProps(nextProp) {
		this.setState({ open: nextProp.hasError })
	}

	render() {
		return (
			<Modal open={this.state.open} onClose={this.close}>
				<Modal.Header>System Message</Modal.Header>
				<Modal.Content>
					{
						this.props.hasError 
						&& this.props.error != null 
						&& this.props.error.code != undefined
						&& this.props.error.message != undefined
						&& <Modal.Description>
								<p>Error Code : {this.props.error.code}</p>
								<p>Error Message : {this.props.error.message}</p>
							</Modal.Description>
					}
				</Modal.Content>
				<Modal.Actions>
					<Button
						positive
						icon='checkmark'
						labelPosition='right'
						content="OK"
						onClick={this.close}
						onClose={this.close}
					/>
				</Modal.Actions>
			</Modal>
		)
	}
}

export default compose(
	connect(
		(state, props) => ({
			hasError: getHasError(state),
			error: getError(state),
		}),
		(dispatch) => ({
            clearError() {
                dispatch(setError(false))
            },
        })
	)

)(ErrorMessage)


// WEBPACK FOOTER //
// ./src/features/ui/components/ErrorMessageDialog.js